import Application from "../../Application";
import GetAllOrganisationsInteractor from "../../organisations/interactors/GetAllOrganisationsInteractor";
import CaseDecisionPresenter, {
  ICaseDecisionPresenter
} from "../presenter/CaseDecisionPresenter";

import GetAllCaseDecisionsInteractor from "./GetAllCaseDecisionsInteractor";
import GetGenericCodebookInteractor from "../../codebooks/interactor/GetGenericCodebookInteractor";
import GetAllCaseDecisionTypesInteractor from "./GetAllCaseDecisionTypesInteractor";

export default class ShowCaseDecisionsInteractor {
  private application: Application;
  private output?: ICaseDecisionPresenter;
  private getAllCaseDecisionsInteractor: GetAllCaseDecisionsInteractor;
  private getAllCaseDecisionTypesInteractor: GetAllCaseDecisionTypesInteractor;
  private getGenericCodebookInteractor: GetGenericCodebookInteractor;
  private getAllOrganisations: GetAllOrganisationsInteractor;

  constructor({
    application,
    getAllCaseDecisions,
    getGenericCodebook,
    getAllOrganisations,
    getAllCaseDecisionTypes
  }: any) {
    this.application = application;
    this.getAllCaseDecisionsInteractor = getAllCaseDecisions;
    this.getAllOrganisations = getAllOrganisations;
    this.getGenericCodebookInteractor = getGenericCodebook;
    this.getAllCaseDecisionTypesInteractor = getAllCaseDecisionTypes;
  }

  private async getAllCaseDecisions() {
    return this.getAllCaseDecisionsInteractor.execute();
  }
  private async getAllCaseDecisionTypes() {
    return this.getAllCaseDecisionTypesInteractor.execute();
  }
  private async getOrganisations() {
    return this.getAllOrganisations.execute();
  }

  private async getReferenceLists() {
    return Promise.all([
      this.getAllCaseDecisions(),
      this.getAllCaseDecisionTypes(),
      this.getContentTypes(),
      this.getOrganisations()
    ]);
  }

  private async getContentTypes() {
    return this.getGenericCodebookInteractor.execute(
      "ATTACHMENT_CONTENT_TYPE",
      false
    );
  }

  execute() {
    this.output = CaseDecisionPresenter({
      application: this.application,
      initialState: {
        caseDecisionList: [],

        caseDecisionTypeOrganisationIndex: [],
        caseDecisionTypes: [],
        selectedOrganisationIndexIds: [],
        organisations: [],
        createModalVisible: false
      }
    });
    this.getReferenceLists().then(
      ([caseDecisions, caseDecisionTypes, contentTypes, organisations]) => {
        this.output?.loadReferenceValues(
          caseDecisionTypes,
          contentTypes,
          organisations
        );
        this.output?.loadCaseDecisions(caseDecisions);
      }
    );
    return this.output;
  }
}
